import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-remove",
  "use": "icon-remove-usage",
  "viewBox": "0 0 13 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 15\" id=\"icon-remove\"><g stroke=\"#000\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.477 15H2.523C1.682 15 1 14.346 1 13.539V3h11v10.539c0 .807-.682 1.461-1.523 1.461zM0 3h13M7 7v4M9 7v4M4 7v4M7.305 0h-1.61c-.439 0-.833.324-.991.816L4 3h5L8.296.816C8.137.324 7.744 0 7.306 0z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol